/**
 * Exports radio button-related design tokens
 */

import { token } from '../utils';

export const labelVariant = false;
export const borderWidth = '2px';
export const borderRadius = 'round';
export const transitionDuration = 'short';
export const formElementZIndex = 'back'; // hide <input type="radio" />

/**
 * Radio Button appearence.
 * Can define 'dot', 'background', 'border', properties for color as well as 'shadow' for the box shadow. 
 * This can be set for all possible states e.g. hover or disabled.
 */
export const appearance = {
    border: 'gray/40',
    background: 'gray/90',

    disabled: {
        border: 'gray/60',
    },

    hover: {
        border: 'primary/50',
        background: 'black',
    },

    checked: {
        border: 'primary/50',
        dot: 'primary/50',

        disabled: {
            border: 'gray/60',
            dot: 'gray/60',
        },

        hover: {
            border: 'primary/80',
            background: 'black',
        },
    },

    invalid: {
        border: 'alert/50',
        background: 'gray/90',

        disabled: {
            border: 'gray/60',
        },

        hover: {
            border: 'alert/80',
            background: 'black',
        },

        checked: {
            border: 'alert/50',
            background: 'gray/90',
            dot: 'alert/50',

            disabled: {
                border: 'gray/60',
                background: 'gray/90',
                dot: 'gray/60',
            },

            hover: {
                border: 'alert/80',
                background: 'black',
            },
        },

    },

};

/**
 * Radio Button sizes defined as design token.
 * 'size' - height and width of the box
 * 'gap' - gap between the box and label
 * 'dot' - inner circle diameter
 * 'label' - Label's 'kind'
 */
export const size = token('checkboxSize', [{
    key: 'medium',
    order: 2,
    value: {
        size: 2,
        dot: 1,
        label: 'medium',
        gap: 1,
    },
}]);

export const defaultSize = 'medium';